'use client';

import cn from 'classnames';
import { useEffect, useRef, useState } from 'react';

export function SplitTextMulti(props) {
  const delay = typeof props.delay !== 'undefined' ? props.delay : 1;
  const speed = typeof props.speed !== 'undefined' ? props.speed : 25;

  const [isVisible, setVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !isVisible) {
          setVisible(true);
        }
      });
    });
    if (domRef.current) observer.observe(domRef.current);
    return () => {
      observer.disconnect();
    };
  });

  let delays = [];
  let currentDelay = 0;
  let lastDelay = 0;
  let lastIndex = 0;
  let indexExtra = 0;
  let indexToUse = 0;

  let useCopy = props.copy.replace('<br>', '~');

  return (
    <span
      key={
        typeof props.useUnique !== 'undefined' && props.useUnique
          ? props.copy
          : Math.random()
      }
      ref={domRef}
      role={props.role}
      aria-level={props['aria-level'] ?? 1}
    >
      {useCopy.split('~').map(function (splitChars, mainIndex) {
        indexExtra = mainIndex === 0 ? lastIndex : lastIndex + 1;
        return (
          <span key={mainIndex} className={cn('block')}>
            <span>
              {splitChars.split(' ').map(function (word, index) {
                return (
                  <span
                    key={index}
                    className={cn(
                      'whitespace-nowrap',
                      'overflow-hidden align-top inline-block ',
                      index > 0 ? 'px-[.05em]' : '',
                    )}
                  >
                    {word.split('').map(function (char, index2) {
                      indexToUse = index + indexExtra;
                      lastDelay =
                        typeof delays[indexToUse - 1] !== 'undefined'
                          ? delays[indexToUse - 1].slice(-1)[0]
                          : 0;

                      if (index === 0 && mainIndex === 0)
                        currentDelay = delay + index2 / speed;
                      else currentDelay = index2 / speed + lastDelay;

                      let style = {
                        animationDelay: currentDelay.toFixed(2) + 's',
                      };
                      if (typeof delays[index + indexExtra] === 'undefined')
                        delays[indexToUse] = [];
                      delays[indexToUse].push(currentDelay);
                      lastIndex = indexToUse;
                      return (
                        <span
                          className={cn(
                            'inline-block',
                            isVisible ? 'move visible' : 'invisible',
                          )}
                          aria-hidden="true"
                          key={index2}
                          style={style}
                        >
                          {char}
                        </span>
                      );
                    })}
                    <span className={cn('-mx-[0.05em]')}>&nbsp;</span>
                  </span>
                );
              })}
            </span>
          </span>
        );
      })}
    </span>
  );
}
